<template>
    <v-card>
        <v-card-title class="text-h5 bg-grey-lighten-2" primary-title>
            {{ title }}
        </v-card-title>
        <v-card-text>
            <v-form class="pt-8">
                <v-row dense>
                    <v-col
                        v-for="formField in formFields"
                        :cols="getColsForFormField(formField)"
                        :key="formField.name"
                    >
                        <slot v-if="formField.prependSlot" :name="formField.prependSlot"></slot>
                        <div
                            v-if="
                                formField.fieldType === 'text' || formField.fieldType === 'number'
                            "
                        >
                            <v-text-field
                                :label="formField.fieldDisplayName"
                                v-model="formField.value"
                                :disabled="formField.disabled"
                                :rules="formField.validationRules"
                                :type="formField.fieldType === 'number' ? 'number' : 'text'"
                                @update:model-value="handleFieldChanged($event, formField)"
                            />
                        </div>
                        <div v-else-if="formField.fieldType === 'radioButtons'">
                            <label>{{ formField.fieldDisplayName }}</label>
                            <v-radio-group
                                v-model="formField.value"
                                :rules="formField.validationRules"
                                @update:model-value="handleFieldChanged($event, formField)"
                            >
                                <v-radio
                                    v-for="option in formField.options"
                                    :key="option.value"
                                    :label="option.title || option.label || option.text"
                                    :value="option.value"
                                    :disabled="option.disabled"
                                ></v-radio>
                            </v-radio-group>
                        </div>
                        <div v-else-if="formField.fieldType === 'multiselect'">
                            <label>{{ formField.fieldDisplayName }}</label>
                            <ul>
                                <li
                                    v-for="option in formField.options"
                                    :key="option.value"
                                    style="list-style: none"
                                >
                                    <v-checkbox
                                        density="compact"
                                        @update:model-value="handleFieldChanged($event, formField)"
                                        class="ma-0"
                                        v-model="formField.values"
                                        :label="option.title || option.label || option.text"
                                        color="blue"
                                        hide-details
                                        multiple
                                        :disabled="option.disabled"
                                        :value="option.value"
                                    ></v-checkbox>
                                </li>
                            </ul>
                        </div>
                        <div v-else-if="formField.fieldType === 'select'">
                            <v-autocomplete
                                :items="formField.options"
                                v-model="formField.value"
                                :label="formField.fieldDisplayName"
                                :rules="formField.validationRules"
                                :disabled="formField.disabled"
                                @update:model-value="handleFieldChanged($event, formField)"
                            />
                        </div>
                        <div v-else-if="formField.fieldType === 'date'">
                            <v-text-field
                                type="date"
                                v-model="formField.value"
                                :label="formField.fieldDisplayName"
                                :rules="formField.validationRules"
                                @update:model-value="handleFieldChanged($event, formField)"
                                style="width: 360px"
                            />
                        </div>
                        <div v-else-if="formField.fieldType === 'datetime'">
                            <v-text-field
                                type="datetime-local"
                                v-model="formField.value"
                                :label="formField.fieldDisplayName"
                                :rules="formField.validationRules"
                                :disabled="formField.disabled"
                            />
                        </div>
                        <div v-else-if="formField.fieldType === 'boolean'">
                            <v-checkbox
                                v-model="formField.value"
                                :label="formField.fieldDisplayName"
                                :rules="formField.validationRules"
                                :disabled="formField.disabled"
                                @update:model-value="handleFieldChanged($event, formField)"
                            />
                        </div>
                        <div v-else-if="formField.fieldType === 'slot'">
                            <slot :name="formField.slot"></slot>
                        </div>
                        <slot v-if="formField.appendSlot" :name="formField.appendSlot"></slot>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="cancel"> Cancel </v-btn>
            <v-btn color="primary" @click="save"> Save </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ModelForm",

    props: {
        title: String,
        formFields: Array,
    },

    methods: {
        getColsForFormField(formField) {
            if (formField.cols) {
                return formField.cols;
            } else {
                // defaults to 2 columns
                return "6";
            }
        },
        handleFieldChanged(value, formField) {
            if (formField.changed) {
                formField.changed(value, formField);
            }
        },
        save() {
            this.$emit("save", this.formFields);
        },
        cancel() {
            this.$emit("cancel", this.formFields);
        },
    },
});
</script>

<style></style>
